import script from "./ChatBotMsgComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBotMsgComp.vue?vue&type=script&setup=true&lang=js"

import "./ChatBotMsgComp.vue?vue&type=style&index=0&id=abbfba9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abbfba9e"]])

export default __exports__